import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en_translation from './translations/en_translation.json';
import da_translation from './translations/da_translation.json';
import de_translation from './translations/de_translation.json';
import es_translation from './translations/es_translation.json';
import fr_translation from './translations/fr_translation.json';
import it_translation from './translations/it_translation.json';
import nl_translation from './translations/nl_translation.json';
import no_translation from './translations/no_translation.json';
import pt_translation from './translations/pt_translation.json';
import sv_translation from './translations/sv_translation.json';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            "en": {translation: en_translation},       
            "da": {translation: da_translation},          
            "de": {translation: de_translation},          
            "es": {translation: es_translation},          
            "fr": {translation: fr_translation},          
            "it": {translation: it_translation},          
            "nl": {translation: nl_translation},          
            "no": {translation: no_translation},          
            "pt": {translation: pt_translation},          
            "sv": {translation: sv_translation}       
        }
    });

export default i18n;